import { useTranslation } from 'react-i18next';
import { EventDetailsForm } from 'components/EventForms';
import { Box } from '@mui/material';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import {
  SectionTitle,
  SvgCalendar3Bold,
} from '@insights-ltd/design-library/components';
import { StepProps } from './types';
import FormNavigation from './FormNavigation';

const EventDetails = ({ onBack, onNext, event, updateEvent }: StepProps) => {
  const { t } = useTranslation();

  const onSubmit = (formData: any) => {
    updateEvent(formData);
    onNext();
  };

  return (
    <>
      <Box
        sx={{
          mt: spacingSizeMap.L,
          mb: spacingSizeMap.L,
        }}
      >
        <SectionTitle
          icon={{ icon: <SvgCalendar3Bold />, iconColour: 'pink' }}
          text={t('ui.event-management.events.create.event-details')}
        />
      </Box>
      <EventDetailsForm
        event={event}
        onSubmit={onSubmit}
        invitedCount={0}
        isCreating
      >
        {({ isSubmitDisabled }) => (
          <FormNavigation onBack={onBack} disabled={isSubmitDisabled} />
        )}
      </EventDetailsForm>
    </>
  );
};

export default EventDetails;
